import React from 'react'

import Layout from '../../../pages/layout'

export type VideoLayoutProps = {
  children: JSX.Element
}

export default function VideoLayout(props: VideoLayoutProps) {
  return (
    <Layout>
      <div style={{ marginTop: '27px', padding: '2.5rem 0' }}>
        {props.children}
      </div>
    </Layout>
  )
}
